<template>
    <div :class="cardClass">
        <template v-if="!isLoading">
            <div class="RPTableGraphCard__header-bar">
                <div class="RPTableGraphCard__header">
                    <slot name="header">
                        <span class="RPTableGraphCard__header-text">{{ header }}</span>
                        <RPTooltip
                            v-if="headerTooltip !== ''"
                            class="RPTableGraphCard__header-tooltip"
                            :tooltip="headerTooltip"
                        />
                    </slot>
                </div>
                <div class="RPTableGraphCard__title-action">
                    <slot name="action"></slot>
                </div>
            </div>
            <div class="RPTableGraphCard__chart">
                <div class="RPTableGraphCard__chart-header">
                    <span class="RPTableGraphCard__name-header">{{ nameHeader }}</span>
                    <span class="RPTableGraphCard__data-header">{{ dataHeader }}</span>
                </div>
                <div
                    v-for="(rowData, index) in tableData"
                    :key="JSON.stringify(rowData)+index"
                    class="RPTableGraphCard__data-row"
                >
                    <span class="RPTableGraphCard__row-id">{{ index }}</span>
                    <span class="RPTableGraphCard__row-name">
                        <slot
                            name="rowName"
                            :rowData="rowData"
                        >{{ rowData.name }}</slot>
                    </span>
                    <span class="RPTableGraphCard__row-data">
                        <slot
                            name="rowData"
                            :rowData="rowData"
                        >{{ rowData.data }}</slot>
                    </span>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import RPTooltip from 'components/Basic/Misc/RPTooltip.vue';
import stat from 'status';
import statusBuilder from 'status/statusBuilder';

export default {
    name: 'RPTableGraphCard',
    components: {
        RPTooltip,
    },
    props: {
        header: {
            type: String,
            required: true
        },
        headerTooltip: {
            type: String,
            default: ''
        },
        nameHeader: {
            type: String,
            required: true
        },
        dataHeader: {
            type: String,
            required: true
        },
        tableData: {
            type: Array,
            required: true,
        },
        status: {
            type: String,
            default: stat.STANDBY,
        }
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },
        cardClass(){
            return statusBuilder('RPTableGraphCard', this.status);
        },
    },
};
</script>
<style lang="scss">
    .RPTableGraphCard {
        background: $white;
        padding: 1rem 1rem 0 1rem;
        border-radius: 4px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
        display: flex;
        flex-direction: column;

        @include loading(100%, 100%);

        &__header-bar {
            display: flex;
            align-items: center;
            margin-bottom: 1rem;
        }
        &__header {
            display: flex;
            align-items: center;
            flex-grow: 1;
        }
        &__header-text {
            color: $text-dark;
            font-weight: 600;
        }
        &__header-tooltip {
            margin-left: 0.25rem;
        }
        &__chart-header {
            display: flex;
            padding: 0 .25rem;
            margin-bottom: 1rem;
            border-bottom: 1px solid $grey-100;
        }
        &__name-header,
        &__data-header {
            color: $text-dark;
        }
        &__name-header {
            flex-grow: 1;
        }

        &__data-row {
            display: flex;
            align-items: center;
            font-size: 1rem;
            color: $text-grey;
            padding: 0 .25rem;
            margin-bottom: 1rem;
        }
        &__row-id {
            text-align: center;
            width: 1rem;
            font-size: 0.75rem;
        }
        &__row-name {
            flex-grow: 1;
        }
        &__row-data {
            font-weight: 600;
        }
    }
</style>
